// packages/common/src/sse/useNotificationsSSE.ts
import { useCallback, useRef } from 'react';
import { useSSE } from './useSSE';

export type NewNotificationPayload = {
  action?: string;
  type?: string;
  campaign_id?: string;
  notification_id?: string;
  category?: 'message' | 'activity';
  title?: string;
  body?: string;
  teaser?: string;
  creator_name?: string;
  creator_username?: string;
  entry_id?: string;
  thread_type?: 'selection' | 'script' | 'content';
  thread_locked?: boolean;
  deep_link?: string;
};

interface Options {
  enabled: boolean;
  onNewNotification: (payload: NewNotificationPayload) => void;
}

/** Subscribes to the `new_notification` SSE nudge; the handler refetches the
 *  inbox/badge (the DB is the source of truth). Mirrors useThreadsSSE. */
export function useNotificationsSSE({ enabled, onNewNotification }: Options): void {
  const ref = useRef(onNewNotification);
  ref.current = onNewNotification;

  const handler = useCallback((payload: Record<string, unknown>) => {
    ref.current(payload as NewNotificationPayload);
  }, []);

  useSSE('new_notification', enabled, handler);
}
